// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_a49fbfd5","message":"_10e8100d","countdown":"_940d0a37"};